/*
Ashraf 11/30/2022  2698948956 changed url for udw
*/

import {createSlice} from '@reduxjs/toolkit';
import {httpGet} from '../../../util/Rest';

const initialData = {
  udwData: [],
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'UdwWindows',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchUdwWindows: (state, action) => {
      state.udwData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
      state.accountLegalStatus = null;
    },
    resetMsg: (state) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
  },
});

export default slice.reducer;

// Actions

const {fetchStart, fetchError, fetchUdwWindows} = slice.actions;

export const fetchUDW = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`custom/window/getall/window`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchUdwWindows(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
